/**
 * Created by commyfeng on 2017/3/21.
 */

'use strict';

import "core-js/modules/es6.regexp.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import * as urlBuilder from "./url";
import RequestError from "../../lib/RequestError";
import RequestErrorType from "../../lib/RequestErrorType";
var BASE_URL = (typeof location !== 'undefined' ? location.protocol : 'http:') + '//btrace.qq.com/kvcollect';
var assign = require('lodash/assign');
function handle() {}
function _report(url) {
  var reportObj = document.createElement("img");
  reportObj.onerror = handle;
  reportObj.onload = handle;
  reportObj.onabort = handle;
  reportObj.src = url;
  //setTimeout(handle, 100);
}
;

/**
 *@param cfg object {bossId:xxx, pwd: xxx}
 */
function Boss(cfg) {
  if (!cfg || !cfg.bossId || !cfg.pwd) {
    throw new Error('[report.Boss]bossId and pwd is required');
  }
  this._cfg = cfg;
  this._baseUrl = urlBuilder.buildUrl(BASE_URL, {
    BossId: cfg.bossId,
    Pwd: cfg.pwd
  });
}
Boss.prototype = {
  _baseUrl: '',
  report: function report(params) {
    _report(this.buildReportUrl(params));
    return this;
  },
  buildReportUrl: function buildReportUrl(params) {
    return urlBuilder.buildUrl(this._baseUrl, params, true);
  }
};
var defaultOptions = {
  bossId: 4358,
  pwd: 1659229905
};
export default function (options) {
  if (typeof window == 'undefined') {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(next) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return next();
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  }
  var boss = new Boss(assign({}, defaultOptions, options));
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(next) {
      var params;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              params = {
                protocol: (this.request.protocol || location.protocol).replace(':', ''),
                host: this.request.hostname,
                ftime: new Date(),
                path: this.request.pathname,
                query: urlBuilder.buildQueryStr(assign({}, this.request.data, this.request.query))
              };
              _context2.prev = 1;
              _context2.next = 4;
              return next();
            case 4:
              _context2.next = 10;
              break;
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](1);
              if (_context2.t0 instanceof RequestError) {
                params.delay = new Date() - params.ftime;
                if (_context2.t0.errorType === RequestErrorType.NETWORK_ERR) {
                  params.httpcode = 404;
                } else {
                  params.httpcode = 200;
                  params.bizcode = _context2.t0.code;
                  params.bizmsg = _context2.t0.msg;
                }
                setTimeout(function () {
                  boss.report(params);
                }, 0);
              }
              throw _context2.t0;
            case 10:
              params.delay = new Date() - params.ftime;
              params.httpcode = 200;
              params.bizcode = 0;
              params.bizmsg = 'ok';
              setTimeout(function () {
                boss.report(params);
              }, 0);
            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[1, 6]]);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
}